// import "./WinnersLand.css";
import { useTheme, useCountUp } from "../WinnerLand/useTheme";

// function StatNum({ value, suffix }) {
//   const count = useCountUp(value);

//   return (
//     <span className="ws-stat-num">
//       {count.toLocaleString()}
//       <span> {suffix}</span>
//     </span>
//   );
// }

// function WinnersStats() {
//   const stats = [
//     {
//       value: 1,
//       suffix: "Lakh+",
//       label: "Active properties listed",
//     },
//     {
//       value: 25,
//       suffix: "Crore",
//       label: "Total property value",
//     },
//     {
//       value: 20,
//       suffix: "Cities",
//       label: "Premium urban markets",
//     },
//     {
//       value: 1600,
//       suffix: "Localities",
//       label: "Neighbourhoods covered",
//     },
//   ];

//   return (
//     <section className="ws-stats">
//       <div className="ws-stats-grid">
//         {stats.map((item) => (
//           <div
//             className="ws-stat"
//             key={item.label}
//           >
//             <StatNum
//               value={item.value}
//               suffix={item.suffix}
//             />

//             <div className="ws-stat-label">
//               {item.label}
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

function StatNum({ value, suffix }) {
  const v = useCountUp(value);
  return <span className="ws-stat-num">{v.toLocaleString()}<span> {suffix}</span></span>;
}
export function WinnersStats() {
  const stats = [
    { value: 1, suffix: "Lakh+", label: "Active properties listed" },
    { value: 25, suffix: "Crore", label: "Total property value" },
    { value: 20, suffix: "Cities", label: "Premium urban markets" },
    { value: 1600, suffix: "Localities", label: "Neighbourhoods covered" },
  ];
  return (
    <section className="ws-stats">
      <div className="ws-stats-grid">
        {stats.map((s) => (
          <div className="ws-stat" key={s.label}>
            <StatNum value={s.value} suffix={s.suffix} />
            <div className="ws-stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WinnersStats;